import { Requests } from '@tools/requests';

export const requestsMixin = {
  methods: { get: Requests.get, post: Requests.post, patch: Requests.patch, delete: Requests.delete, put: Requests.put },
};
